export default __webpack_public_path__ + "static/media/REinscrições-mestrados-banner-.c865ea9f.jpg";